import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_conduct_regular_reviews_andor_assessments_of_socia'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_conduct_regular_reviews_andor_assessments_of_socia',
  name: 'Does the facility conduct regular reviews and/or assessments of social and labor practices?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_CONDUCTS_REGULAR_INTERNAL_REVIEWS_AND_OR_ASSESSMENTS_O',
      text: 'Facility conducts regular internal reviews and/or assessments of all social and labor policies and procedures that the facility has implemented',
      externalIds: [
        {
          id: 'ms-6-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_CONDUCTS_REGULAR_REVIEWS_AND_OR_ASSESSMENTS_OF_SOCIAL_',
      text: 'Facility conducts regular reviews and/or assessments of social and labor practices within their supply chain, i.e. of suppliers and subcontractors, including raw materials suppliers',
      externalIds: [
        {
          id: 'ms-6-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_KEEPS_RECORDS_OF_THESE_ASSESSMENTS_AND_ANY_VIOLATIONS_',
      text: 'Facility keeps records of these assessments and any violations that were uncovered',
      externalIds: [
        {
          id: 'ms-6-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RESULTS_ARE_REPORTED_TO_SENIOR_MANAGEMENT',
      text: 'Results are reported to senior management',
      externalIds: [
        {
          id: 'ms-6-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_DOES_NOT_PERFORM_REGULAR_REVIEWS_AND_OR_ASSESSMENTS_ON',
      text: 'Facility does not perform regular reviews and/or assessments on social and labor practices within the facility and/or within their supply chain',
      externalIds: [
        {
          id: 'ms-6-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_CONDUCTS_REGULAR_INTERNAL_REVIEWS_AND_OR_ASSESSMENTS_O',
                'FACILITY_CONDUCTS_REGULAR_REVIEWS_AND_OR_ASSESSMENTS_OF_SOCIAL_',
                'FACILITY_KEEPS_RECORDS_OF_THESE_ASSESSMENTS_AND_ANY_VIOLATIONS_',
                'RESULTS_ARE_REPORTED_TO_SENIOR_MANAGEMENT',
                'FACILITY_DOES_NOT_PERFORM_REGULAR_REVIEWS_AND_OR_ASSESSMENTS_ON',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-che-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 23140,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
